<template>
  <div>
    <loader></loader>
    <div class="creator">
      <product-canvas />
      <navigation v-if="showNavigation" />
    </div>
    <component
      :is="routeComponent"
      v-if="null !== routeComponent"
      v-bind="routeProps"
    />
    <modals-container></modals-container>
  </div>
</template>
<script>
import ProductCanvas from './ProductCanvas.vue';
import Navigation from './Navigation.vue';
import Loader from './Loader.vue';
import ProductSummaryBar from './ProductSummaryBar.vue';
import { ACTION_LOAD_PRODUCT } from '@/store/modules/product/action-types';
import { MUTATION_SET_PRINT_SIDE } from '@/store/mutation-types';
import { ACTION_AWAIT_REQUEST } from '@/store/action-types';
import { TrackingMixin } from '@/mixins/gtm-tracking';
import { mapActions } from 'vuex';
import { GETTER_SHOW_NAVIGATION } from '@/store/getters';
import { mapState } from 'pinia';
import { useRouterStore } from '@/store-pinia/router';
import routerInit from '@/store-pinia/router/router-init';
import { ModalsContainer } from 'vue-final-modal';

export default {
  name: 'Creator',
  components: {
    ProductCanvas,
    Navigation,
    ProductSummaryBar,
    Loader,
    ModalsContainer
  },
  mixins: [TrackingMixin],
  computed: {
    showNavigation() {
      return this.$store.getters[GETTER_SHOW_NAVIGATION];
    },
    ...mapState(useRouterStore, [
      'routeComponent',
      'routeProps',
      'routeDefinition'
    ])
  },
  watch: {
    async '$route.params.articleNumber'(articleNumber) {
      await this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
        await this[`product/${ACTION_LOAD_PRODUCT}`]({
          articleNumber
        });
        this.$store.commit(MUTATION_SET_PRINT_SIDE, 'front');
      });
    },
    routeDefinition(routeDefinition) {
      // Route Tracking
      if (
        null === routeDefinition ||
        !Object.prototype.hasOwnProperty.call(routeDefinition, 'tracking')
      ) {
        return;
      }

      this.trackPath({
        virtPath: routeDefinition.name,
        ...routeDefinition.tracking
      });
    }
  },
  async created() {
    routerInit();

    await this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
      await this[`product/${ACTION_LOAD_PRODUCT}`]({
        articleNumber: this.$route.params.articleNumber
      });
    });

    // @TODO double check if there is a better way to register components dynamically.
    this.$options.components = {
      ...this.$options.components,
      ...useRouterStore().routeComponents
    };
  },
  mounted() {
    this.trackPath({
      virtPath: 'root',
      contentGroup2: 'Creator_Overview',
      contentGroup3: 'Creator_Overview'
    });
  },
  methods: {
    ...mapActions([`product/${ACTION_LOAD_PRODUCT}`])
  }
};
</script>

<style lang="scss" scoped>
.creator {
  @apply h-full bg-sh-pale-grey relative overflow-hidden flex flex-col w-full;
}
@screen xs {
  .creator {
    height: calc(100vh - 140px) !important;
  }
}
@screen md {
  .creator {
    height: 660px !important;
  }
}
</style>
